
import { Options, Vue, prop } from "vue-class-component";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import ImagePreview from "./image-preview.vue";
import { DexAssessment } from "@/domain/entities/PusatResolusiV2";

class Props {
  modelValue = prop<boolean>({
    type: Boolean,
    default: false
  });
  dexData = prop<DexAssessment[]>({
    type: Array,
    required: true
  });
}

@Options({
  emits: ["update:modelValue"],
  components: {
    ImagePreview
  }
})
export default class ModalDexAssessment extends Vue.with(Props) {
  previewPhoto = false;
  previewPhotoIndex = 0;
  dexIndex = 0;

  set openDialog(value: boolean) {
    this.$emit("update:modelValue", value);
  }

  get openDialog() {
    return this.modelValue;
  }

  closeDialog() {
    this.$emit("update:modelValue", false);
  }

  formatDateFormatting(date: string) {
    return formatDate(date, "DD MMMM YYYY, HH:mm");
  }

  mapStatus(daStatus: string) {
    const label: any = {
      valid: this.$t('pusatResolusi.valid'),
      invalid: this.$t('pusatResolusi.notValid')
    };

    const style: any = {
      valid: "bg-green-lp-500 border-green-lp-200 text-green-lp-400",
      invalid: "bg-red-lp-1300 border-red-lp-600 text-red-lp-2400"
    };

    return {
      label: label[daStatus] ?? "-",
      style: style[daStatus] ?? ""
    };
  }

  proofPhoto(index: number) {
    return this.dexData[index].daDeliveryProofPhotoDex.split(",");
  }

  onPreview(index: number, photoIndex: number) {
    this.dexIndex = index;
    this.previewPhotoIndex = photoIndex;
    this.previewPhoto = !this.previewPhoto;
  }
}
